import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AuthProvider } from './../auth/auth';
import { UserSettings } from './../../models/UserSettings';
import { AngularFireDatabase } from 'angularfire2/database';

/*
  Generated class for the SettingsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SettingsProvider {

  notifications: boolean = false;

  constructor(
    private auth: AuthProvider,
    private db: AngularFireDatabase,
    private platform: Platform
    ) {
  }

  public getUserSettings(): Observable<UserSettings>{
    return this.auth.getUserId().flatMap(uid => {
      if(uid){
        let path = `settings/${uid}`;
        let obj = this.db.object<UserSettings>(path);
        return obj.valueChanges().catch((error, caught) => {
          return Observable.of(null);
        })
      }else{
        return Observable.of(null);
      }
    })

  }

  public setUserSettings(settings: any){
    return this.auth.getUserId().flatMap(uid => {
      if(uid){
        let path = `settings/${uid}`;
        let obj = this.db.object(path);
        return obj.update(settings);
      }else{
        return Observable.of(null);
      }
    }).first();
  }

}



// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts